// with polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import permission from './directive/permission'
import style from './directive/style'
import store from './store/'
// 1. 混入必须最先注册
import confirmClose from '@/mixins/confirmClose' // 必须出现
import i18n from './locales'
import { VueAxios } from './utils/request'
import ProLayout, { PageHeaderWrapper } from '@/components/ProLayout'
import FooterToolBar from '@/components/FooterToolbar'
import FileUpload from '@/components/FileUpload'
import themePluginConfig from '../config/themePluginConfig'
import { TableSetting } from '@/components'
import VueAMap from 'vue-amap'
import { Timeline, Cascader, Collapse } from 'ant-design-vue'
import LoadingPop from '@/components/Loading/loading.vue'
import '@/utils/lib-flexible'
// 字典数据组件
import DictData from '@/components/DictData'
// 字典标签组件
import DictTag from '@/components/DictTag'
// main.js 或者相应的组件文件
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import bootstrap from './core/bootstrap'
import './core/lazy_use' // use lazy load components
import './permission' // permission control
import './utils/filter' // global filter
import './global.less' // global style
import '@/assets/css/main.css' // ruoyi css main.css
import { getDicts } from '@/api/system/dict/data'
import { getConfigKey } from '@/api/system/config'
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree, tableSorter } from '@/utils/ruoyi'
import { download } from '@/utils/request'
import Distpicker from 'v-distpicker'
import echarts from 'echarts'

import { formatStorageCapacity, formatStorageCapacityWithDecimal } from '@/utils/format'
Vue.mixin(confirmClose)
Vue.prototype.$echarts = echarts
if (process.env.VUE_APP_BASE_API == 'https://gdj-fw.shengj.cn/admin-api') {
  // 正式cos 地址
  Vue.prototype.$url = 'https://hfile.shengj.cn/'
  Vue.prototype.$Preview = 'https://gdj.shengj.cn/'
  Vue.prototype.$Bucket = 'hoy-1308702491'
  Vue.prototype.$baseUrl = 'https://vr.guandaojia.cn?id='
  Vue.prototype.$payUrl = 'https://vr.guandaojia.cn/pay/index.html#/pages/index/paymentPlan'
  Vue.prototype.$paySmsUrl = 'https://vr.guandaojia.cn/pay/index.html#/pages/index/smsOrder'

  Vue.prototype.$ChangelogUrl = 'https://wx.guandaojia.cn/Changelog/index.html#/pages/index/index'
} else {
  // 测试cos 地址
  Vue.prototype.$url = 'https://hfile-test.shengj.cn/'
  Vue.prototype.$Bucket = 'hoy-test-1308702491'
  Vue.prototype.$Preview = 'https://test-ys.guandaojia.cn/'
  Vue.prototype.$baseUrl = 'https://vrce.guandaojia.cn?id='
  Vue.prototype.$payUrl = 'https://vrce.guandaojia.cn/pay/index.html#/pages/index/paymentPlan'
  Vue.prototype.$paySmsUrl = 'https://vrce.guandaojia.cn/pay/index.html#/pages/index/smsOrder'

  Vue.prototype.$ChangelogUrl = 'https://test-ys.guandaojia.cn/Changelog/index.html#/pages/index/index'
}

// 全局注册格式化函数https://test-ys.guandaojia.cn/Changelog/index.html#/pages/index/index
Vue.prototype.$formatCapacity = formatStorageCapacity
Vue.prototype.$formatCapacityWithDecimal = formatStorageCapacityWithDecimal

Vue.prototype.$cosUrl = 'hoy/oth'
Vue.use(Timeline)
Vue.use(Collapse)
Vue.component('LoadingPop', LoadingPop)
Vue.use(Cascader)
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: '4cbc715ff0724c9b60ec616315b0c660',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geocoder', 'AMap.Marker'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4',
})
if (process.env.VUE_APP_BASE_API == 'https://gdj-fw.shengj.cn/admin-api') {
  // 正式cos 地址
  Vue.prototype.$url = 'https://hfile.shengj.cn/'
  Vue.prototype.$Bucket = 'hoy-1308702491'
} else {
  // 测试cos 地址
  Vue.prototype.$url = 'https://hfile-test.shengj.cn/'
  Vue.prototype.$Bucket = 'hoy-test-1308702491'
}
Vue.prototype.$cosUrl = 'hoy/oth'
Vue.use(Timeline)
Vue.use(Collapse)
Vue.component('LoadingPop', LoadingPop)
Vue.use(Cascader)
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: '4cbc715ff0724c9b60ec616315b0c660',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geocoder', 'AMap.Marker'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4',
})
Vue.component('v-distpicker', Distpicker)
// 全局方法挂载
Vue.prototype.getDicts = getDicts
Vue.prototype.getConfigKey = getConfigKey
Vue.prototype.parseTime = parseTime
// Vue.prototype.tableBordered = true
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.download = download
Vue.prototype.handleTree = handleTree
Vue.prototype.tableSorter = tableSorter
Vue.config.productionTip = false

// mount axios to `Vue.$http` and `this.$http`
Vue.use(VueAxios)
// use pro-layout components
Vue.component('pro-layout', ProLayout)
Vue.component('page-container', PageHeaderWrapper)
Vue.component('page-header-wrapper', PageHeaderWrapper)
Vue.component('footer-tool-bar', FooterToolBar)
Vue.component('file-upload', FileUpload)
Vue.component('table-setting', TableSetting)
Vue.component('dict-tag', DictTag)
Vue.use(permission)
Vue.use(style)
Vue.use(Viewer)
DictData.install()

// if (process.env.NODE_ENV === 'production') {
//   if (window) {
//   }
// }
// 禁止 Ctrl + 鼠标滚轮缩放
document.addEventListener('wheel', function (event) {
  if (event.ctrlKey) {
    event.preventDefault()
  }
}, { passive: false })
window.umi_plugin_ant_themeVar = themePluginConfig.theme
new Vue({
  router,
  store,
  i18n,
  // init localstorage, vuex
  created: bootstrap,
  render: h => h(App),
}).$mount('#app')
